import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useConversation, Conversation } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Conversation>
      useData={useConversation}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
